import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

function Pagination(props) {
  const { pageCount } = props;

  if (pageCount <= 1) {
    return null;
  }

  return (
    <div>
      <ReactPaginate
        previousLabel="&#10094;"
        nextLabel="&#10095;"
        breakClassName="break-me"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        onPageChange={props.handlePageClick}
        containerClassName="pagination"
        subContainerClassName="pages pagination"
        activeClassName="active"
        forcePage={props.currentPage}
      />
    </div>
  );
}

export default Pagination;

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  handlePageClick: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};
